import { Component } from 'react';

import { getMlVasDescription, getMlVasName, getVasDescription, getVasName } from '../../../utils/name';

import { BigAuctionIcon } from './icons/auction';
import { BigColorizedIcon } from './icons/colorized';
import { BigPayedIcon } from './icons/payed';
import { BigPremiumIcon } from './icons/premium';
import { BigTop3Icon } from './icons/top3';

import * as styles from './index.css';

export interface IVasListProps {
  /** Отсортированный список мнемоник VAS'ов объявления */
  vasList: string[];
  /** Любой уникальный ключ (в идеале id объявления), чтобы сгенерировать элементы svg */
  uniqueKey: number | string;
  /** Используется ли ранжированная выдача */
  isMLSearch?: boolean;
}

/**
 * Компонент для отображения списка примененных VAS с описанием каждого VAS
 */
export class VasList extends Component<IVasListProps, object> {
  public render() {
    const { vasList, uniqueKey, isMLSearch } = this.props;

    return (
      <div className={styles['container']}>
        <div className={styles['header']}>К объявлению применены опции:</div>
        <div className={styles['list']}>
          {vasList.map(vas => {
            return (
              <div className={styles['vas']} key={vas}>
                <div className={styles['icon']}>{this.getVasIcon(vas, uniqueKey)}</div>
                <div className={styles['description']}>
                  <div className={styles['description-header']}>
                    {isMLSearch ? getMlVasName(vas, true) : getVasName(vas, true)}
                  </div>
                  <div className={styles['text']}>{isMLSearch ? getMlVasDescription(vas) : getVasDescription(vas)}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles['link']}>
          <a className={styles['link-tag']} href="https://www.cian.ru/promo/adv/" rel="noreferrer" target="_blank">
            Узнать подробнее
          </a>
        </div>
      </div>
    );
  }

  private getVasIcon = (vas: string, id: number | string) => {
    switch (vas) {
      case 'top3':
        return BigTop3Icon(id);
      case 'auction':
        return BigAuctionIcon(id);
      case 'premium':
        return BigPremiumIcon(id);
      case 'payed':
        return BigPayedIcon(id, { style: { width: 40 } });
      case 'colorized':
        return BigColorizedIcon(id);
      default:
        return null;
    }
  };
}
